import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import Mission from './section-components/mission-two';
import Professional from './section-components/professional';
import SellHome from './section-components/sellhome';
import Process from './section-components/process';
import BuyOrSell from './section-components/buy-or-sell';
import Footer from './global-components/footer';
import BlogContact from '../utils/blogContact';

const Advisor = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="We are Real Estate Advisors" subheader="Advisors" />
        <Mission />
        <Professional />
        <SellHome />
        <Process />
        <BuyOrSell />
        <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>
        <Footer />
    </div>
}

export default Advisor

